/* eslint-disable react/display-name */
import { useState, useContext, useEffect } from "react";
import { Paper, Grid } from "@mui/material";
import QRCode from "react-qr-code";

import {
	HealthSmartLogo,
	NexcalEmployeeLogo,
	PhcsLogo,
	ProgressiveLaboratoriesBrandingLogo,
	ProgressiveLaboratoriesLogo,
	ShieldPoweredLOGO
} from "../../../../../assets";
import { AuthContext } from "../../../../../contexts";
import { maskSSN } from "../../../../../constants/maskSSN";
import { getLocalIPV4 } from "../../../../../utils/commonFunctions/getLocalIP4";
import encryption from "../../../../../utils/commonFunctions/encryption";
import { MEMBER_ENV } from "../../../../../config/config";

import "./ProgressiveLabhealthCardActual.css";

const HealthCardActualV2 = () => {
	const [localIP, setLocalIP] = useState("");
	const [urlLink, setUrlLink] = useState("");
	const { member } = useContext(AuthContext);

	// console.log("Member Details", member);
	const _ssn = maskSSN(member?.SSN);

	useEffect(() => {
		// eslint-disable-next-line arrow-parens
		getLocalIPV4().then((ip) => setLocalIP(ip));
	}, []);

	useEffect(() => {
		const { group_number, date_of_birth, SSN } = member;

		if (member && localIP) {
			const localRedirectionLink = `http:${localIP}:3002/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			const prodRedirectionLink = `www.nexcaliber.com/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			if (member && MEMBER_ENV === "LOCAL") setUrlLink(localRedirectionLink);
			if (member && (MEMBER_ENV === "PROD" || MEMBER_ENV === "DEV")) setUrlLink(prodRedirectionLink);
		}
	}, [member, localIP]);
	return (
		<div>
			<div className="employee-id-card-frontside-container">
				<div className="paper-form-container">
					<Paper className="theme-border-radius emp-paper-container" elevation={1}>
						<div className="card-top-header-container">
							<div className="top-header-name-container">Progressive Laboratories, Inc.</div>
							<div className="top-header-row-data">
								<img
									src={HealthSmartLogo}
									style={{
										width: "7rem",
										height: "1.9rem"
										// marginTop: "-10px"
									}}
									alt=""
								/>
								<div style={{ display: "inline-block", fontSize: "0.7rem", fontWeight: "900" }}>
									Administered By Nexcaliber
								</div>
								<img
									src={ProgressiveLaboratoriesLogo}
									alt="Brookshire-logo"
									style={{ width: "7rem", height: "1.7rem", marginTop: "5px" }}
								/>
							</div>
						</div>
						<div
							className="card-header-contact"
							style={{
								fontSize: ".7rem",
								fontWeight: "700",
								textAlign: "center",
								marginBottom: ".7rem"
							}}
						>
							Healthsmart Provider:(800) 687 0500 or{" "}
							<span style={{ fontWeight: "bold" }}>www.healthsmart.com</span>
						</div>
						<div className="border-seperator" />
						<Grid container className="employee-card-details-container">
							<div className="left-details-section">
								<div className="employee-details-description">
									<div
										style={{
											display: "flex",
											gap: "4rem",
											alignItems: "center",
											marginTop: "0.5rem",
											fontSize: "0.7rem",
											fontWeight: "bold"
										}}
									>
										<span style={{ fontWeight: "bold" }}>
											Group Benefit Plan Identification Card
										</span>
										<span style={{ fontWeight: "bold" }}>Group Number: GP300</span>
									</div>
								</div>
							</div>
						</Grid>

						<Grid container className="employee-card-details-container">
							<div className="left-details-section">
								<div className="employee-details-description">
									{/* <div className="plan-identificationc-card-name">
										<span>Group Benefit Plan Identification Card</span>
									</div>
									<div className="group-number-gp" style={{ marginBottom: "-7px" }}>
										<span style={{ fontSize: ".7rem", textWrap: "nowrap" }}>
											Group Number: GP300
										</span>
									</div> */}

									<div className="row-data" style={{ marginTop: "1rem" }}>
										<div className="employee-detail">
											EMPLOYEE : {member.last_name}, {member.first_name}
										</div>
										<div className="employee-detail">ID Number : XXX-XX-{maskSSN(member.SSN)}</div>
										<span
											style={{
												textAlign: "left",
												marginTop: ".2rem",
												fontSize: ".5rem",
												color: "#005AA4"
											}}
										>
											Please obtain missing digits from patient
										</span>
									</div>

									{/* <div className="row-data">
										<span>Taxes Provided Network: </span>
										<span>PHCS Network</span>
									</div>
									<div className="row-data-single-liners">
										PHCS Network www.multiplan.com or (800) 922-4362
									</div>
									<div className="row-data-single-liners">
										Call Network (800) 741-0185 for assistance
									</div> */}
								</div>
							</div>
							<div className="right-details-section">
								{/* <span style={{ fontSize: ".7rem", textWrap: "nowrap" }}>Group Number: GP300</span> */}
								<div
									style={{
										position: "relative",
										borderRadius: "0.5rem",
										height: "5.2rem",
										maxWidth: "120%",
										width: "120%",
										marginBottom: "-0.25rem",
										overflow: "hidden",
										marginLeft: "-1.9rem"
									}}
								>
									<QRCode
										size={256}
										style={{
											height: "4rem",
											maxWidth: "100%",
											width: "100%",
											marginTop: "5px",
											marginLeft: "-5px"
										}}
										value={urlLink}
										fgColor="#4e4e4e"
										bgColor="#ffffff"
									/>

									{/* Pseudo-elements to add borders only on the corners */}
									<div
										style={{
											position: "absolute",
											top: 0,
											left: 0,
											width: "65%",
											height: "90%",
											pointerEvents: "none",
											marginLeft: "0.95rem"
										}}
									>
										{/* Top-left corner */}
										<div
											style={{
												position: "absolute",
												top: 0,
												left: 0,
												borderTop: "1.6px solid rgb(156, 39, 176)",
												borderLeft: "1.6px solid rgb(156, 39, 176)",
												width: "0.75rem",
												height: "0.75rem",
												borderRadius: "0.25rem 0 0 0"
											}}
										/>
										{/* Top-right corner */}
										<div
											style={{
												position: "absolute",
												top: 0,
												right: 0,
												borderTop: "1.6px solid rgb(156, 39, 176)",
												borderRight: "1.6px solid rgb(156, 39, 176)",
												width: "0.75rem",
												height: "0.75rem",
												borderRadius: "0 0.25rem 0 0"
											}}
										/>
										{/* Bottom-left corner */}
										<div
											style={{
												position: "absolute",
												bottom: 0,
												left: 0,
												borderBottom: "1.6px solid rgb(156, 39, 176)",
												borderLeft: "1.6px solid rgb(156, 39, 176)",
												width: "0.75rem",
												height: "0.75rem",
												borderRadius: "0 0 0 0.25rem"
											}}
										/>
										{/* Bottom-right corner */}
										<div
											style={{
												position: "absolute",
												bottom: 0,
												right: 0,
												borderBottom: "1.6px solid rgb(156, 39, 176)",
												borderRight: "1.6px solid rgb(156, 39, 176)",
												width: "0.75rem",
												height: "0.75rem",
												borderRadius: "0 0 0.25rem 0"
											}}
										/>
									</div>
								</div>

								<span style={{ textAlign: "center", marginLeft: "-3.5rem", marginTop: "-0.5rem" }}>
									Scan to check Eligibility
								</span>
							</div>
						</Grid>

						<div className="border-seperator" />
						<Grid container className="employee-card-front-footer" style={{ marginTop: "0.5rem" }}>
							<div
								className="prescription-header"
								style={{ textDecoration: "underline", textAlign: "center", fontWeight: "680" }}
							>
								Prescription Drug Benefit with Shield
							</div>
							<div
								className="prescription-details-container"
								style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}
							>
								<div
									className="left-side-prescription-details"
									style={{ display: "flex", flexDirection: "column", marginTop: "10px" }}
								>
									<div
										className="prescription-details"
										style={{ display: "flex", flexDirection: "row", flex: 1 }}
									>
										<span
											style={{ marginLeft: "-.6rem", marginRight: "1.8rem", fontSize: ".7rem" }}
										>
											BIN: 026556
										</span>
										<span style={{ fontSize: ".7rem" }}>Shield Phone: (877) 659-6101</span>
									</div>
									<div
										className="prescription-details"
										style={{ display: "flex", flexDirection: "row", flex: 1 }}
									>
										<span style={{ marginLeft: "-.6rem", marginRight: ".9rem", fontSize: ".7rem" }}>
											PCN: SHIELD
										</span>
										<span style={{ fontSize: ".7rem", marginLeft: "0.6rem" }}>
											www.shieldpbm.com
										</span>
									</div>
								</div>

								<div className="right-side-prescription-details" style={{ marginTop: "1.4rem" }}>
									<img src={ShieldPoweredLOGO} alt="SHIELD Logo" style={{ width: "8rem" }} />
								</div>
							</div>
						</Grid>
					</Paper>
				</div>
			</div>
			<div className="employee-id-card-backside-container">
				<div className="paper-form-container">
					<Paper className="theme-border-radius emp-paper-container" elevation={1}>
						<div className="card-back-topPortion-container">
							<span style={{ lineHeight: ".3rem" }}>
								<p style={{ fontWeight: 900, display: "inline-block", marginRight: "5px" }}>
									Precertification is required:
								</p>
								Call Spectrum Review services at (800) 258-5055 for any required precertifications or
								prior plan approval of services.
							</span>
						</div>

						<div className="footer-border" />

						<div className="card-back-midPortion-container">
							<div className="upper-section">
								<span>For Online Claim access visit the Health Plan Portal</span>
								<br></br>
								<span>Webpage address is https://member.enrollment.nexcaliber.com</span>
							</div>
							<div className="footer-border" />

							<div className="footer-top-content-container" style={{ padding: "0.2rem" }}>
								<span
									className="footer-top-sub-content"
									style={{ marginLeft: "4px", fontSize: "0.65rem" }}
								>
									Employees: To discuss benefits and/or status of a claim call (972) 248-1011 Or (800)
									741-0185 Mon-Fri 8:30am-5:00pm CST
								</span>
							</div>
						</div>

						<div className="footer-border" />

						<div className="summary-benefits-footer-container">
							<div className="footer-bottom-content" style={{ marginTop: "0.2rem" }}>
								Mail all claims to: NEXCALIBER , PO BOX 802422, DALLAS, TX 75380
							</div>
							<div className="footer-logo-container">
								<img src={NexcalEmployeeLogo} alt="Nexcal employee Logo" />
							</div>
						</div>
					</Paper>
				</div>
			</div>
		</div>
	);
};

export default HealthCardActualV2;
